import { I18nComponente } from "@/types/gerais"

export const MDropdowni18n: I18nComponente = {
  "pt-BR": {
    buscarPorNome: "buscar por nome"
  },
  "es-CO": {
    buscarPorNome: "buscar por nombre"
  }
}
